import {Table, Tag} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {UrlLink, fmt} from "./TechShared";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Robots.txt: trạng thái tìm thấy, crawl-delay, danh sách sitemap khai báo, tập luật
 * Allow/Disallow (đã parse khi bắt đầu crawl) và các URL bị chặn phát hiện khi crawl.
 */
function TechRobots({robots}) {

	const {found, rules = [], sitemaps = [], crawl_delay = 0, blocked = []} = robots || {};

	const ruleColumns = [
		{
			title: 'Loại', dataIndex: 'type', width: 130,
			render: (t) => <Tag color={t === 'allow' ? 'green' : 'volcano'}>{t === 'allow' ? 'Allow' : 'Disallow'}</Tag>,
		},
		{title: 'Đường dẫn', dataIndex: 'path', ellipsis: true, render: (p) => <code>{p || '(trống)'}</code>},
	];

	const blockedColumns = [
		{title: 'URL bị chặn', dataIndex: 'url', ellipsis: true, render: (u, r) => <UrlLink url={u} text={u || r.message} />},
	];

	return (
		<div className={cn('tab')}>
			<div className={cn('robotsHead')}>
				<div className={cn('robotsStat')}>
					<FontAwesomeIcon icon="fa-light fa-robot" />
					<span>robots.txt: <strong className={cn(found ? 'ok' : 'no')}>{found ? 'Tìm thấy' : 'Không tìm thấy'}</strong></span>
				</div>
				<div className={cn('robotsStat')}>
					<FontAwesomeIcon icon="fa-light fa-clock" />
					<span>Crawl-delay: <strong>{crawl_delay ? `${crawl_delay}s` : '—'}</strong></span>
				</div>
			</div>

			<h4 className={cn('sectionTitle')}>Sitemap khai báo ({sitemaps.length})</h4>
			{sitemaps.length === 0 ? (
				<p className={cn('muted')}>robots.txt không khai báo sitemap. Nên thêm dòng <code>Sitemap: https://.../sitemap.xml</code>.</p>
			) : (
				<ul className={cn('sitemapList')}>
					{sitemaps.map((s, i) => <li key={i}><UrlLink url={s} /></li>)}
				</ul>
			)}

			<h4 className={cn('sectionTitle')}>Luật áp dụng cho crawler ({rules.length})</h4>
			<Table size="small" rowKey={(r, i) => i} columns={ruleColumns} dataSource={rules}
				scroll={{x: 'max-content'}} pagination={{pageSize: 15, hideOnSinglePage: true}} />

			<h4 className={cn('sectionTitle')}>URL bị chặn khi crawl ({fmt(blocked.length)})</h4>
			{blocked.length === 0 ? (
				<p className={cn('muted')}>Không có URL nào bị robots.txt chặn trong lần crawl này.</p>
			) : (
				<Table size="small" rowKey={(r, i) => i} columns={blockedColumns} dataSource={blocked}
					scroll={{x: 'max-content'}} pagination={{pageSize: 15, hideOnSinglePage: true}} />
			)}
		</div>
	);
}

export default TechRobots;
